module.exports = __webpack_public_path__ + "static/media/Caixa2.72ef0d5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelCaixa/Caixa2.png
// module id = 2032
// module chunks = 0